import { TOGGLE_MODAL } from './Constants'

export const toggleModal = (dispatch, data) => dispatch(({ type: TOGGLE_MODAL, payload: { data } }))